var e4 = e4 || {};
( function () {
    'use strict';
    e4.settings = {
        lang: ( function () {
            return jQuery( 'html' ).attr( 'lang' );
        }() ),
        separatorInteger: ( function () {
            return jQuery( 'html' ).data( 'separatorInteger' );
        }() ),
        separatorDecimal: ( function () {
            return jQuery( 'html' ).data( 'separatorDecimal' );
        }() ),
        animation: {
            speed: 375
        },
        header: {
            autoHideTolerance: {
                up: 500,
                down: 1000
            }
        },
        nav: {
            revealActive: {
                delay: 400,
                speed: 0.75,
                easing: 'swing'
            },
            flagCDN: 'https://cdn.jsdelivr.net/npm/flag-icon-css@2.8.0/flags/1x1/'
        },
        parallax: {
            speed: -0.35
        },
        scrollReveal: {
            selector: '.js-e-scroll-reveal',
            classConceal: 'e-reveal-conceal',
            classRevealFade: 'e-reveal-fade',
            classRevealSlide: 'e-reveal-slide',
            classRevealDone: 'e-reveal-done',
            classReset: 'reset-transform-containing-block'
        },
        scrollToAnchor: {
            speed: 0.5,
            nudge: 2,
            easing: 'swing',
            stickyElements: '.js-e-header.is-sticky, .js-e-nav-local-horizontal.is-sticky',
            fullscreenElements: '.e-section-height-fullscreen, .p-section-fullscreen, .p-banner-fullscreen',
            backToTop: {
                revealOffset: 3
            }
        },
        forms: {
            validate: {
                messages: {
                    da: {}
                }
            }
        },
        search: {
            debounceDelay: 250,
            result: {
                pages: {
                    show: true,
                    url: '/system/data/pages?q='
                },
                products: {
                    show: true,
                    url: '/system/data/products?q=',
                    showAllLink: '/shop/search?q=',
                    max: {
                        xs: 2,
                        sm: 2,
                        md: 4,
                        lg: 4,
                        xl: 4
                    }
                }
            }
        },
        require: {
            timeout: 2000,
            jQueryValidate: {
                url: '//cdnjs.cloudflare.com/ajax/libs/jquery-validate/1.17.0/jquery.validate.min.js',
                fallback: '/files/system/espresso/design/_assets/js/vendor/jquery.validate.min.js',
                callback: null
            },
            handlebars: {
                url: '//cdnjs.cloudflare.com/ajax/libs/handlebars.js/4.0.11/handlebars.min.js',
                fallback: '/files/system/espresso/design/_assets/js/vendor/handlebars.min.js',
                callback: null // Register helper and compile templates
            },
            MarkerClusterer: {
                url: '//cdnjs.cloudflare.com/ajax/libs/js-marker-clusterer/1.0.0/markerclusterer_compiled.js',
                fallback: '/files/system/espresso/design/_assets/js/vendor/markerclusterer_compiled.js',
                callback: null
            },
            jQueryUImap: {
                url: '//cdnjs.cloudflare.com/ajax/libs/jquery-ui-map/3.0-rc1/min/jquery.ui.map.min.js',
                fallback: '/files/system/espresso/design/_assets/js/vendor/jquery.ui.map.min.js',
                callback: null
            },
            typeahead: {
                url: '//cdnjs.cloudflare.com/ajax/libs/corejs-typeahead/1.1.1/typeahead.jquery.min.js',
                fallback: '/files/system/espresso/design/_assets/js/vendor/typeahead.jquery.min.js',
                callback: null
            },
            drawSVG: {
                url: 'https://cdn.jsdelivr.net/jquery.drawsvg/1.1.0/jquery.drawsvg.min.js',
                fallback: '/files/system/espresso/design/_assets/js/vendor/jquery.drawsvg.min.js',
                callback: null
            }
        },
        ecom: {
            filters: {
                url: '/system/data/facets',
                delay: 350,
                cleanUrl: false
            },
            cart: {
                url: '/system/data/cart',
                msgHideDelay: 10000,
                debounceDelay: 500
            },
            download: {
                url: '/system/data/cart-download'
            },
            quickorder: {
                url: '/system/data/products'
            },
            checkout: {
                url: '/system/data/checkout',
                delay: 500,
                multipageBreakpoint: 'lg',
                shipping: {
                    searchCount: 8
                },
                termsAndConditions: '/shop/terms-and-conditions'
            },
            favoriteProducts:{
                url: '/system/data/favoriteproducts'
            }
        },
        breakpoint: {
            xs: 0,
            sm: 544,
            md: 768,
            lg: 922,
            xl: 1200
        },
        collapse: {
            peekSizeMin: 1.5
        },
        dealersearch: {
            geolocation: true,
            zoom: {
                min: 12,
                max: 15,
                initial: 6
            },
            results: {
                min: 2,
                sensitivity: 0.5
            },
            country: {
                DK: {
                    center: {
                        lat: 56.26392,
                        lng: 9.501785
                    },
                    zoom: 7
                },
                NO: {
                    center: {
                        lat: 60.47202399999999,
                        lng: 8.468945999999999
                    },
                    zoom: 6
                },
                SE: {
                    center: {
                        lat: 60.12816100000001,
                        lng: 18.643501
                    },
                    zoom: 5
                },
                DE: {
                    center: {
                        lat: 51.165691,
                        lng: 10.451526
                    },
                    zoom: 6
                },
                GB: {
                    center: {
                        lat: 55.378051,
                        lng: -3.435973
                    },
                    zoom: 4
                }
            }
        },
        event: {
            namespace: 'e4',
            transitionend: ( function ( domElm ) {
                var objTestTransitionEnd = {
                    'transition': 'transitionend',
                    'OTransition': 'oTransitionEnd',
                    'MSTransition': 'MSTransitionEnd',
                    'WebkitTransition': 'webkitTransitionEnd'
                };
                for ( var name in objTestTransitionEnd ) {
                    if ( domElm.style[ name ] !== undefined ) {
                        return objTestTransitionEnd[ name ];
                    }
                }
                return false;
            } )( document.createElement( 'espresso' ) ),
            animationend: ( function ( domElm ) {
                var objTestAnimationEnd = {
                    'animation': 'animationend',
                    'OAnimation': 'oAnimationEnd',
                    'MSAnimation': 'MSAnimationEnd',
                    'WebkitAnimation': 'webkitAnimationEnd'
                };
                for ( var name in objTestAnimationEnd ) {
                    if ( domElm.style[ name ] !== undefined ) {
                        return objTestAnimationEnd[ name ];
                    }
                }
                return false;
            } )( document.createElement( 'espresso' ) )
        },
        cookieAcceptLink: '/admin/public/CookieOptInLevelConfig.aspx?cmd=SetCookieOptInLevel&OptInLevel=2'
    };
}() );

